import { Circle, CircleContent } from "./styled";
import React from "react";
export const StepIcon = ({ active, step, stepCompleteIcon, stepNumber, branding, }) => {
    return (React.createElement(Circle, { active: active, complete: step.complete, branding: branding },
        React.createElement(CircleContent, { active: active, branding: branding }, step.complete && stepCompleteIcon ? (React.createElement(React.Fragment, null, stepCompleteIcon)) : (React.createElement("div", { "data-testid": "step-number" }, stepNumber)))));
};
//# sourceMappingURL=index.js.map